import type { Category, MilestoneDefinition, Tier } from './types'
import { TIER_MAPPINGS } from './evolution'

function pickTierLabel(value: number, thresholds: readonly number[]): Tier {
  if (value >= thresholds[3]) return 'platinum'
  if (value >= thresholds[2]) return 'gold'
  if (value >= thresholds[1]) return 'silver'
  return 'bronze'
}

function generateMilestonesFor(category: Category): MilestoneDefinition[] {
  const m = TIER_MAPPINGS[category]
  const out: MilestoneDefinition[] = []
  for (let v = m.milestoneStep; v <= m.milestoneMax; v += m.milestoneStep) {
    const tier = pickTierLabel(v, m.tierThresholds)
    out.push({
      id: `${m.metric}.gte.${v}`,
      category,
      tier,
      scale: 'mini',
      metric: m.metric,
      threshold: v,
      direction: 'gte',
      oneShot: true,
      titleKey: `milestones.${category}.${v}.title`,
      flavorKey: `milestones.${category}.${v}.flavor`,
    })
  }
  return out
}

// Spolehlivost ani Servis se negenerují — obojí se počítá z incidentů,
// které zatím nesbíráme. Vrátit, až bude napojený support systém.
export const DEFAULT_MILESTONES: MilestoneDefinition[] = [
  ...generateMilestonesFor('growth'),
  ...generateMilestonesFor('revenue'),
]
